import { FileText, BookOpenText, Wind, GraduationCap, TvMinimalPlay, Podcast } from 'lucide-react';
import ebooksImg from 'assets/wellbeing/AUTOCUIDADO_PAE_Eboks_img.webp';
import ejerciciosImg from 'assets/wellbeing/AUTOCUIDADO_PAE_Ejercicios_img.webp';
import formacionImg from 'assets/wellbeing/AUTOCUIDADO_PAE_Formacion_img.webp';
import podcastsImg from 'assets/wellbeing/AUTOCUIDADO_PAE_Podcasts_img.webp';
import videoTipsImg from 'assets/wellbeing/AUTOCUIDADO_PAE_Videotips_img.webp';
import articulosImg from 'assets/wellbeing/ariculosbanner.webp';
import { ROUTES } from 'constants/routes';

export interface WellBeingCategory {
  id: string;
  titleKey: string;
  descriptionKey: string;
  buttonKey: string;
  image: string;
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  route: string;
  isAvailable: boolean;
}

export const categories: WellBeingCategory[] = [
  // {
  //   id: 'wellbeing-test',
  //   titleKey: 'WellBeing.categories.test.title',
  //   descriptionKey: 'WellBeing.categories.test.description',
  //   buttonKey: 'WellBeing.categories.test.button',
  //   image: valoraBienestarImg,
  //   icon: NotebookPen,
  //   route: ROUTES.WELL_BEING_TEST,
  //   isAvailable: true,
  // },
  {
    id: 'trainings',
    titleKey: 'WellBeing.Categories.Trainings.heading',
    descriptionKey: 'WellBeing.Categories.Trainings.body',
    buttonKey: 'WellBeing.Categories.Trainings.cta',
    image: formacionImg,
    icon: GraduationCap,
    route: `${ROUTES.WELL_BEING}/trainings`,
    isAvailable: true,
  },
  {
    id: 'tips',
    titleKey: 'WellBeing.Categories.Tips.heading',
    descriptionKey: 'WellBeing.Categories.Tips.body',
    buttonKey: 'WellBeing.Categories.Tips.cta',
    image: videoTipsImg,
    icon: TvMinimalPlay,
    route: `${ROUTES.WELL_BEING}/tips`,
    isAvailable: true,
  },
  {
    id: 'ebooks',
    titleKey: 'WellBeing.Categories.Ebooks.heading',
    descriptionKey: 'WellBeing.Categories.Ebooks.body',
    buttonKey: 'WellBeing.Categories.Ebooks.cta',
    image: ebooksImg,
    icon: BookOpenText,
    route: `${ROUTES.WELL_BEING}/ebooks`,
    isAvailable: true,
  },
  {
    id: 'exercises',
    titleKey: 'WellBeing.Categories.Exercises.heading',
    descriptionKey: 'WellBeing.Categories.Exercises.body',
    buttonKey: 'WellBeing.Categories.Exercises.cta',
    image: ejerciciosImg,
    icon: Wind,
    route: `${ROUTES.WELL_BEING}/exercises`,
    isAvailable: true,
  },
  {
    id: 'articles',
    titleKey: 'WellBeing.Categories.Articles.heading',
    descriptionKey: 'WellBeing.Categories.Articles.body',
    buttonKey: 'WellBeing.Categories.Articles.cta',
    image: articulosImg,
    icon: FileText,
    route: `${ROUTES.WELL_BEING}/articles`,
    isAvailable: true,
  },
  {
    id: 'podcasts',
    titleKey: 'WellBeing.Categories.Podcasts.heading',
    descriptionKey: 'WellBeing.Categories.Podcasts.body',
    buttonKey: 'WellBeing.Categories.Podcasts.cta',
    image: podcastsImg,
    icon: Podcast,
    route: `${ROUTES.WELL_BEING}/podcasts`,
    isAvailable: true,
  },
];
